module.exports = __webpack_public_path__ + "img/logo-easypallet.4242a065.png";